import React from 'react';

const Home = () => {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>HOMEPAGE</h1>
    </>
  );
};

export default Home;